import { convertToHTML } from "draft-convert";
import { EditorState } from "draft-js";
import React, { useState } from "react";
// import UploadSuperstarAuction from "../UploadSuperstarAuction/UploadSuperstarAuction";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import "./AddProductAuctionSuperstar.css";
import useFileHandleS3 from "../../../../../../CustomHooks/useFileHandleS3";
import useProductImageHandleS3 from "../../../../../../CustomHooks/useProductImageHandleS3";
import MediaUploadProgressBar from "../../../../../../Screen/MediaUploadProgressBar";

const AddProductAuctionSuperstar = () => {
  const [convertedContent, setConvertedContent] = useState(null);
  const [banner, setBanner] = useState(null);
  const [product, setProduct] = useState(null);
  const [errorList, setErrorList] = useState([]);
  const [loading, setLoading] = useState(false);

  const history = useHistory();

  const [editorState, setEditorState] = useState(() =>
    EditorState.createEmpty()
  );

  // File Handle Banner
  const [file, setFile] = useState("");
  const [delKey, setDelKey] = useState(null);
  const [fileUrl, fileKey, progress] = useFileHandleS3(file, 'auction/images', delKey);


  // File Handle Product Image
  const [productImage, setProductImage] = useState('');
  const [productImageDelKey, setProductImageDelKey] = useState(null);
  const [productImageUrl,productImageKey,progressBar] = useProductImageHandleS3(productImage, 'auction/images', productImageDelKey);

  const [inputFieldList, setInputFieldList] = useState({
    title: "",
    keyword: "",
    details: "",
    base_price: "",
    bid_from: "",
    bid_to: "",
    result_date: "",
    product_delivery_date: "",
    banner: "",
    product_image: "",
  });

  const handleInput = (e) => {
    const { name, value } = e.target;
    setInputFieldList((prev) => {
      return { ...prev, [name]: value };
    });
  };

  const handleEditorChange = (state) => {
    setEditorState(state);
    convertContentToHTML();
  };

  const convertContentToHTML = () => {
    let currentContentAsHTML = convertToHTML(editorState.getCurrentContent());
    setConvertedContent(currentContentAsHTML);
  };

  const [imageUpload, setImageUpload] = useState({
    upload: {
      pictures: [],
      maxFileSize: 5242880,
      imgExtension: [".jpg", ".png", ".jpeg"],
      defaultImages: [],
    },
  });

  const handleAuctionChange = (files) => {
    const { pictures } = imageUpload.upload;
    console.warn({ pictures, files });

    setImageUpload({
      ...imageUpload,
      upload: {
        ...imageUpload.upload,
        pictures: [...pictures, ...files],
      },
    });
  };

  const bannerHandler = (file) => {
    setDelKey(fileKey);
    setFile(file[0]);
  };

  const productImageHandler = (file) => {
    setProductImageDelKey(productImageKey);
    setProductImage(file[0]);
  };


  const dataSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    const fData = new FormData();

    fData.append("title", inputFieldList.title);
    fData.append("keyword", inputFieldList.keyword);
    fData.append("details", convertedContent);
    fData.append("base_price", inputFieldList.base_price);
    fData.append("bid_from", inputFieldList.bid_from);
    fData.append("bid_to", inputFieldList.bid_to);
    fData.append("result_date", inputFieldList.result_date);
    fData.append("product_delivery_date", inputFieldList.product_delivery_date);
    fData.append("banner", fileKey);
    fData.append("status", 0);
    fData.append("product_image", productImageKey);

    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios.post(`/api/star/add/auction/product`, fData).then((res) => {
        if (res.data.status === 402) {
          setErrorList(res.data.errors);
        } else {
          history.push("/superstar/auction-product-list/unSold");
        }
        setLoading(false);
      });
    });
  };

  return (
    <div className="AS ">
      <div className="text-light d-flex border border-warning rounded-3 justify-content-center p-2 m-1">
        <div className="faTrophy">
          <i className="fa-solid fa-calendar-plus"></i>
        </div>
        <h4 className="mx-3 text-warning p-2">Add Product</h4>
      </div>

      <div className="card card-bg mb-2 p-2 mt-3 ">
        <div className="card card-bg m-2">
          <div className="container-lg">
            <div className="row">
              <div className="clo-sm-12 col-md-12 col-lg-9 mx-auto">
                <form>
                  <div className="row my-4">
                    <div className="col-md-3 label-text">
                      <p>Title</p>
                    </div>
                    <div className="col-md-9">
                      <input
                        className="form-control reply-control"
                        type="text"
                        onChange={handleInput}
                        placeholder="Enter title"
                        name="title"
                        value={inputFieldList.title}
                      />
                      <span className="text-danger">{errorList.title}</span>
                    </div>
                  </div>

                  <div className="row my-4">
                    <div className="col-md-3 label-text">
                      <p>Keyword</p>
                    </div>
                    <div className="col-md-9">
                      <input
                        placeholder="Enter keyword"
                        className="form-control reply-control"
                        type="text"
                        onChange={handleInput}
                        name="keyword"
                        value={inputFieldList.keyword}
                      />
                      <span className="text-danger">{errorList.keyword}</span>
                    </div>
                  </div>

                  <div className="row my-4">
                    <div className="col-md-3 label-text">
                      <p>Description</p>
                    </div>
                    <div className="col-md-9">
                      <CKEditor
                        editor={ClassicEditor}
                        data={convertedContent}
                        onReady={(editor) => {
                          // You can store the "editor" and use when it is needed.
                        }}
                        onChange={(event, editor) => {
                          const data = editor.getData();
                          setConvertedContent(data);
                        }}
                      />
                      <span className="text-danger">{errorList.details}</span>
                    </div>
                  </div>

                  <div className="row my-4">
                    <div className="col-md-3 label-text">
                      <p>Base Price</p>
                    </div>
                    <div className="col-md-9">
                      <input
                        className="form-control reply-control"
                        type="number"
                        name="base_price"
                        onChange={handleInput}
                        value={inputFieldList.base_price}
                        placeholder="Enter base price $"
                      />
                      <span className="text-danger">
                        {errorList.base_price}
                      </span>
                    </div>
                  </div>

                  <div className="row my-4 label-text">
                    <div className="col-md-3 label-text label-text">
                      <p>Bidding Deadline</p>
                    </div>
                    <div className="col-sm-4">
                      <input
                        type="date"
                        className="form-control reply-controlDate"
                        onChange={handleInput}
                        name="bid_from"
                        value={inputFieldList.bid_from}
                      />
                      <span className="text-danger">{errorList?.bid_from}</span>
                    </div>{" "}
                    To
                    <div className="col-sm-4">
                      <input
                        type="date"
                        className="form-control reply-controlDate"
                        onChange={handleInput}
                        name="bid_to"
                        value={inputFieldList.bid_to}
                      />
                      <span className="text-danger">{errorList?.bid_to}</span>
                    </div>
                  </div>

                  <div className="row my-4">
                    <div className="col-md-3 label-text label-text">
                      <p>Result Published</p>
                    </div>

                    <div className="col-sm-5">
                      <input
                        type="date"
                        className="form-control reply-controlDate"
                        onChange={handleInput}
                        name="result_date"
                        value={inputFieldList.result_date}
                      />
                      <span className="text-danger">
                        {errorList?.result_date}
                      </span>
                    </div>
                  </div>
                  <div className="row my-4">
                    <div className="col-md-3 label-text label-text">
                      <p>Product Delivery</p>
                    </div>
                    <div className="col-sm-5">
                      <input
                        type="date"
                        className="form-control reply-controlDate"
                        onChange={handleInput}
                        name="product_delivery_date"
                        value={inputFieldList.product_delivery_date}
                      />
                      <span className="text-danger">
                        {errorList?.product_delivery_date}
                      </span>
                    </div>
                  </div>
                  {/* <div className="row"> */}

                  {/* <div className="col-md-4"> */}
                  <div className="row my-4">
                    <div className="col-md-3 label-text label-text">
                      <p>Upload Banner</p>
                    </div>
                    <div className="col-md-5">
                      {fileUrl ? (
                        <img
                          src={fileUrl}
                          className="demo-preview-image img-fluid mb-1"
                          alt=""
                          style={{
                            height: "200px",
                            width: "300px",
                          }}
                        />
                      ) : (
                        ""
                      )}
                      <input
                        onChange={(e) => bannerHandler(e.target.files)}
                        type="file"
                        name="banner"
                        id="file"
                        className="inputfile"
                      />
                     {file && !fileUrl && <MediaUploadProgressBar progress={progress} />}
                      <label for="file">
                        <i className="fas fa-cloud-upload-alt"></i> Upload
                      </label>
                      <span className="text-danger">{errorList.banner}</span>
                    </div>
                  </div>
                  {file ? (
                    <div className="row">
                      <div className="col-md-3 label-text label-text">
                        <small>Selected Banner</small>
                      </div>
                      <div className="col-md-9 fw-bold text-success">
                        {file?.name}
                      </div>
                    </div>
                  ) : null}

                  <div className="row my-4">
                    <div className="col-md-3 label-text label-text">
                      <p>Product Image</p>
                    </div>
                    <div className="col-md-5">
                      {productImageUrl ? (
                        <img
                          src={productImageUrl}
                          className="demo-preview-image img-fluid mb-1"
                          alt=""
                          style={{
                            height: "200px",
                            width: "300px",
                          }}
                        />
                      ) : (
                        ""
                      )}
                      <input
                        onChange={(e) => productImageHandler(e.target.files)}
                        type="file"
                        name="product_image"
                        id="product"
                        className="inputfile"
                      />
                     
                     {productImage && !productImageUrl && <MediaUploadProgressBar progress={progressBar} />}

                      <label for="product">
                        <i className="fas fa-cloud-upload-alt"></i> Upload
                      </label>
                      <span className="text-danger">
                        {errorList.product_image}
                      </span>
                    </div>
                  </div>
                  {product ? (
                    <div className="row">
                      <div className="col-md-3 label-text label-text">
                        <small>Selected Product</small>
                      </div>
                      <div className="col-md-9 fw-bold text-success">
                        {product?.name}
                      </div>
                    </div>
                  ) : null}

                  {/* Create Submit */}
                  <div className="row justify-content-center aligns-items-center my-4 mt-5">
                    <div className="col-md-3 label-text"></div>
                    <div className="col-md-9 d-flex justify-content-center aligns-items-center">
                      {loading ? (
                        <>
                          <button className="btn btnCreate">
                            <i className="fas fa-spinner fa-pulse"></i>{" "}
                          </button>
                        </>
                      ) : (
                        <button
                          className="btn btnCreate fw-bold"
                          type="submit"
                          onClick={dataSubmit}
                        >
                          Save
                        </button>
                      )}
                    </div>
                  </div>
                  {/* Create Submit End */}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddProductAuctionSuperstar;
